var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 567,
    viewBox: "0 0 800 567",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M633.85 0H166.15C74.3877 0 0 74.3877 0 166.15V399.95C0 491.713 74.3877 566.1 166.15 566.1H633.85C725.612 566.1 800 491.713 800 399.95V166.15C800 74.3877 725.612 0 633.85 0ZM521.484 294.425L302.726 398.76C296.897 401.54 290.163 397.29 290.163 390.833V175.642C290.163 169.093 297.074 164.848 302.915 167.809L521.673 278.665C528.178 281.96 528.065 291.288 521.484 294.425Z",
    fill: "#FFBE10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoYoutube);
export default __webpack_public_path__ + "static/media/ico-youtube.15d90fb0b1c20727de6c0c115976df5c.svg";
export { ForwardRef as ReactComponent };